<template>
    <task-group-list
        :abstractSchemaConfig="schemaConfig"
        :task-groups="taskGroups"
        :readout-groups="readoutGroups"
        @create="createTaskGroup"
        @update="updateTaskGroup"
        @delete="deleteTaskGroup"
    />
</template>
<script setup lang="ts">
import { SavedSchemaConfigDTO } from "@/services/schemas/manageSchemasAPI";
import { SavedTaskGroup, TaskGroup, taskGroupsAPI } from "@/services/taskGroups/taskGroupsAPI";
import { SavedReadoutGroup } from "@/services/readoutGroups/readoutGroupsAPI";
import { withLoadingScreen } from "@/lib/loading";
import TaskGroupList from "@/components/Measurements/TaskGroupList.vue";

const { schemaConfig, taskGroups, readoutGroups } = defineProps<{
    schemaConfig: SavedSchemaConfigDTO,
    taskGroups: SavedTaskGroup[],
    readoutGroups: SavedReadoutGroup[]
}>();

const emit = defineEmits<{
    (e: "saved");
    (e: "deleted");
}>()

function createTaskGroup(taskGroup: TaskGroup) {
    return save(() => taskGroupsAPI.bySchemaConfig(schemaConfig.id).create(taskGroup));
}

function updateTaskGroup(taskGroup: SavedTaskGroup) {
    return save(() => taskGroupsAPI.bySchemaConfig(schemaConfig.id).update(taskGroup));
}

async function save(saveFn: any) {
    return withLoadingScreen(async () => {
        await saveFn();
        emit("saved");
    });
}

async function deleteTaskGroup(taskGroup: SavedTaskGroup) {
    return withLoadingScreen(async () => {
        await taskGroupsAPI.bySchemaConfig(schemaConfig.id).delete(taskGroup.id);
        emit("deleted");
    });
}

</script>
